import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import "./firebase";

Modal.setAppElement("#root");

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
